export default "__VITE_ASSET__qrc59GM9__"